import React from 'react';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import FormLabel from '@active/react-ui/FormLabel';
import Input from '@active/react-ui/Input';
import Locale from '@active/react-utils/i18n/Locale';
import Popover from '@active/react-ui/Popover';
import { bicValidator, ibanValidator } from '../../utils/validators';
import SaveInWallet from '../SaveInWallet';

const EUDD = ({ allowSavingAccount, forceSaveInWallet, i18n }) => {
  const bicValidate = (value) => {
    return bicValidator(i18n, value);
  };
  const ibanValidate = (value) => {
    return ibanValidator(i18n, value);
  };
  return (
    <React.Fragment>
      <FormGroup name="accountName" required>
        <FormLabel htmlFor="accountName" >
          <Locale id="checkout.lib.components.payment.eudd.name" />
        </FormLabel>
        <FormField
          maxlength="50"
          autoComplete="off"
          id="accountName"
          as={Input}/>
      </FormGroup>
      <FormGroup name="bicCode" required>
        <div className="eudd-bic">
          <FormLabel htmlFor="bicCode" >
            <Locale id="checkout.lib.components.payment.eudd.bic" />
          </FormLabel>
          <Popover
            placement="top"
            style={{ zIndex: 10 }}
            theme="dark"
            content={<Locale id="checkout.lib.components.payment.eudd.bic.hint" />}>
            <span className="ic-question-r eudd-bic--icon" data-popover-trigger >
            </span>
          </Popover>
        </div>
        <FormField
          id="bicCode"
          autoComplete="off"
          as={Input}
          validate={bicValidate}/>
      </FormGroup>
      <FormGroup name="iban" required>
        <div className="eudd-iban">
          <FormLabel htmlFor="iban" >
            <Locale id="checkout.lib.components.payment.eudd.iban" />
          </FormLabel>
          <Popover
            placement="top"
            style={{ zIndex: 10 }}
            theme="dark"
            content={<Locale id="checkout.lib.components.payment.eudd.iban.hint" />}>
            <span className="ic-question-r eudd-iban--icon" data-popover-trigger >
            </span>
          </Popover>
        </div>
        <FormField
          id="iban"
          autoComplete="off"
          as={Input}
          validate={ibanValidate}/>
      </FormGroup>
      <SaveInWallet allowSavingAccount={allowSavingAccount} forceSaveInWallet={forceSaveInWallet}/>
    </React.Fragment>
  );
};

EUDD.type = 'EUDD';
EUDD.defaultValues = {
  accountName: '',
  bicCode: '',
  iban: '',
  savingAccount: [],
};
export default EUDD;
